import gql from 'graphql-tag'

export const getCreditsUsageForEmailVerificationQuery = gql`
  query getCreditsUsageForEmailVerification {
    getCreditsUsageForEmailVerification
  }
`
